import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '../global';
import { SariMetricsResponse } from '../../interfaces/sari-metrics.interface';

export interface SariUploadFilters {
  fecha_inicio?: string | null;
  fecha_fin?: string | null;
  equipo?: string | null;
  prioridad?: string | null;
  tipo?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class SariMetricsService {
  private readonly baseUrl: string;

  constructor(private readonly http: HttpClient) {
    this.baseUrl = Global.url ? `${Global.url.replace(/\/$/, '')}/sari/metrics` : '/api/v1/sari/metrics';
  }

  /**
   * Sube un archivo CSV y opcionales filtros; retorna las métricas calculadas.
   */
  uploadAndGetMetrics(file: File, filters?: SariUploadFilters): Observable<SariMetricsResponse> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    if (filters) {
      if (filters.fecha_inicio != null) formData.append('fecha_inicio', filters.fecha_inicio);
      if (filters.fecha_fin != null) formData.append('fecha_fin', filters.fecha_fin);
      if (filters.equipo != null) formData.append('equipo', filters.equipo);
      if (filters.prioridad != null) formData.append('prioridad', filters.prioridad);
      if (filters.tipo != null) formData.append('tipo', filters.tipo);
    }

    const token = localStorage.getItem('authToken');
    const headers = new HttpHeaders({
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    });

    return this.http.post<SariMetricsResponse>(this.baseUrl, formData, { headers });
  }
}
